import type { ImpersonationSessionState } from '@highlight-cp/hooks';

import type { ClientPortalAppSession } from '../../auth/appSession';

function parsePositiveInteger(value: unknown): number | undefined {
  if (typeof value === 'string') {
    value = Number(value.trim());
  }

  if (typeof value !== 'number') {
    return undefined;
  }

  if (!Number.isSafeInteger(value)) {
    return undefined;
  }

  if (value <= 0) {
    return undefined;
  }

  return value;
}

export function toLegacyImpersonationSessionState(
  clientPortalSession: ClientPortalAppSession | null | undefined,
): ImpersonationSessionState | null {
  if (!clientPortalSession) {
    return null;
  }

  const userId = parsePositiveInteger(clientPortalSession.user_id);

  if (clientPortalSession.impersonation === true && clientPortalSession.impersonation_target) {
    return {
      user_id: userId,
      impersonation: true,
      impersonation_target: clientPortalSession.impersonation_target,
      impersonator: clientPortalSession.impersonator,
      role: clientPortalSession.role,
    };
  }

  // Admin-scoped sessions keep `role: 'admin'` without `impersonation: true`:
  // they have no `impersonation_target`, and flagging them would send
  // `useGetCurrentUser` down its fetch-by-target-email path. `role` plus
  // `impersonator` is what `isEmployeeActingAsCustomerSession` and the
  // IMPERSONATING banner need.
  return {
    user_id: userId,
    impersonator: clientPortalSession.impersonator,
    role: clientPortalSession.role,
  };
}
